const garageTaskColorToken = (type: string | undefined): string => {
  if (type === 'GARAGE' || type === 'ORDER' || type === 'Werkstättenauftrag') {
    return 'primary';
  } else if (type === 'PRODUCT' || type === 'Handelsauftrag') {
    return 'secondary';
  } else if (
    type === 'PLAN' ||
    type === 'GARAGE_TASK' ||
    type === 'UNPRODUCTIVE' ||
    type?.includes('WT')
  ) {
    return 'tertiary';
  }
  return 'danger';
};

export const garageTaskColor = (prop: string, type: string | undefined): string =>
  `${prop}-${garageTaskColorToken(type)}`;

export const garageTaskColorVar = (type: string | undefined): string => {
  switch (garageTaskColorToken(type)) {
    case 'primary':
      return 'var(--colorPrimary)';
    case 'secondary':
      return 'var(--colorSecondary)';
    case 'tertiary':
      return 'var(--colorTertiary)';
    default:
      return 'var(--colorDanger)';
  }
};
